export type ColorLamp = 'green' | 'blue' | 'purple' | 'white' | 'red' | 'yellow' | 'orange';

export enum Positions {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}

// maybe reuse type
export enum Colors {
  GREEN = 'green',
  BLUE = 'blue',
  PURPLE = 'purple',
  WHITE = 'white',
  RED = 'red',
  YELLOW = 'yellow',
  ORANGE = 'orange',
}
